namespace RioERP.Web.Enums {
    export enum FranchiseeDiscountType {
        ExcludingProductShare = 1,
        IncludingProductShare = 2
    }
    Serenity.Decorators.registerEnumType(FranchiseeDiscountType, 'RioERP.Web.Enums.FranchiseeDiscountType');
}
